import '@/installCompositionApi'
import '@/installFineMq'

import { mount } from '@/mounter'

import SanitasTravelEntryModule from './SanitasTravelEntryModule'

mount('travel-entry', SanitasTravelEntryModule)
